type Action = () => void;

export default class ViewModelV2 {
    renderVc?: () => void;

    emit(action: Action) {
        action();

        if (this.renderVc) this.renderVc();
    }
}